module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./LyBrightActionView.js"));
	}, "LyBrightActionView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=LyBrightActionView!./src/pages/Shop/Home/LyBrightAction/LyBrightActionView.js
// module id = 1427
// module chunks = 418